import { initLoadMoreList } from "../shared/load-more-list";

document.addEventListener("DOMContentLoaded", function() {
    if (typeof engeto_loadmore_events_params !== 'undefined') {
        initLoadMoreList({
            buttonSelector: ".events-list-load-more",
            containerSelector: ".events-list-container .posts",
            action: "loadmore_events",
            params: engeto_loadmore_events_params
        });
    }
});